/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';

import Layout from '../../../../common/components/layout/Layout';
// import StepsPlay from '../../../../common/components/modules/home/StepsPlay';
import Header from '../../../../common/components/layout/Header';
import { IDetailsAttribute } from '../../../../common/interfaces';
import CardList from '../../../../common/components/sections/CardList';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../../common/loading/Loading';
import { getGameBysport } from '../../../../modules/sport/actions/reducerListGame';
import { dateList } from '../../../../common/data/dateList';
import { resetGame } from '../../../../modules/sport/actions/reducerGame';
import DefaultImage from '../../../../common/components/images/sports/futbol/default.png';
import { attributesBySport } from '../../../../common/data/attributes';
import { format } from 'date-fns';
import { ghostGameTotal } from '../../../../common/data/ghost';
import { formatPrice } from '../../../../utils';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Matches = (): JSX.Element => {
    const attribute = attributesBySport('integrate');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const query = useQuery();
    const day = query.get('day');
    const date = day ? dateList().find((i) => parseInt(i.id) === parseInt(day)).dateFormat : '';
    const region = query.get('region');
    const commune = query.get('commune');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const filter = {
        day,
        date,
        region,
        commune,
        sport,
    };
    const [listGames, setListGames] = useState<Array<IDetailsAttribute>>([]);
    const selectListGames = (state: any) => state.listGames;
    const games = useSelector(selectListGames);
    const [list, setList] = useState<Array<IDetailsAttribute>>([]);
    const startHour = format(new Date(), "H':'m");

    useEffect(() => {
        dispatch(getGameBysport({ sport, startHour }));
        dispatch(resetGame);
    }, []);

    useEffect(() => {
        setListGames([]);
        if (games) {
            let items = games.data?.data;
            items =
                items && items.length > 0
                    ? items.map((c) => {
                          const reservedPlayer = ghostGameTotal(c, sport);
                          return {
                              id: c.gameId,
                              title: `${reservedPlayer}/${c.gameMaxCapacity} CONFIRMADOS`,
                              subtitle: `${c.culbName}`,
                              day: c.stringDateFormat,
                              hrs: `${format(new Date(c.gameStart), "H':'mm")} Hrs. -${format(
                                  new Date(c.gameEnd),
                                  "H':'mm",
                              )} Hrs. `,
                              commune: c.clubCounty,
                              image: c.photo ? c.photo : DefaultImage,
                              club: formatPrice(c.gamePricePerPlayer, 0),
                              dateFormat: c.gameDate,
                              clubRegion: c.clubRegion,
                              clubCounty: c.clubCounty,
                              maxCapacity: c.gameMaxCapacity,
                              reservedPlayer: reservedPlayer,
                              clubCountyId: c.clubCountyId,
                              clubRegionId: c.clubRegionId,
                          };
                      })
                    : [];
            setList(items);
            //console.log({ items });
            if (items && items.length > 0) {
                if (date) {
                    items = items.filter((item) => item.dateFormat === date);
                }
                if (region) {
                    //console.log({ region });
                    items = items.filter((item) => item.clubRegionId === region);
                }
                if (commune) {
                    items = items.filter((item) => item.clubCountyId === commune);
                }
            }
            //console.log({ items });
            setListGames(items);
        }
    }, [games]);

    const listDetails = {
        title: 'Partidos',
        subTitle: 'Selecciona tu Partido',
    };

    return (
        <Layout navProps={{ title: 'Integrar | Supermatch', description: 'Integrar Supermatch' }}>
            <>
                <Header />
                {games.isLoading ? (
                    <div className="flex items-center justify-center">
                        <Loading />
                    </div>
                ) : games.error && games.error.code ? (
                    <div className="flex items-center justify-center lg:h-96 mb:h-96">
                        <p className="text-2xl text-sm-blue-primary">
                            El Servicio no está Disponible en estos momentos
                        </p>
                    </div>
                ) : (
                    <CardList
                        attribute={attribute}
                        items={listGames}
                        listDetails={listDetails}
                        filter={filter}
                        origin={'integrate'}
                        list={list}
                    />
                )}

                {/* <StepsPlay /> */}
            </>
        </Layout>
    );
};

export default Matches;
